import { de, type Messages } from './de';
import { en } from './en';
import { getLang } from './lang';

export { getLang, getLocale, resolveLang, setLang, watchLang, type Lang } from './lang';
export { industryLabel, otherLabel, stateLabel, statusLabel, typeLabel } from './labels';
export { dataLabel, hasDataTranslations, loadDataTranslations, whenDataReady, type DataDomain } from './data';
export type { Messages };

const MESSAGES = { de, en } as const;

/** The UI strings for the widget language. The language is fixed per mount
    (see lang.ts), so this is a plain lookup — usable in components, hooks and
    non-React code (exports) alike. */
export function t(): Messages {
  return MESSAGES[getLang()];
}

/** Component-side alias of t(), for readability: `const m = useT();`. */
export const useT = t;
